



function projectSlider() {


    if (jQuery(".mjrprjctsec-tpl-m7 .js-mjprcrsl-s1").length) {


        jQuery('.mjrprjctsec-tpl-m7 .js-mjprcrsl-s1').owlCarousel({
            loop: true,
            lazyLoad: true,
            margin: 29,
            items: 4,
            center: true,
            dots: false,
            nav: true,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            navText: ["<i class='nf nf-larrw'></i>", "<i class='nf nf-rarrw'></i>"],
            responsive: {
                0: {
                    items: 1.35,
                    margin: 15,
                    nav: false,
                    center: false,
                },
                400: {
                    items: 1.35,
                    margin: 15,
                    nav: false,
                    center: false,
                },
                480: {
                    items: 1.35,
                    margin: 40,
                    nav: false,
                    center: false,
                },
                576: {
                    items: 1.6,
                    margin: 30,
                    center: false,
                    autoWidth: false,
                    nav: false,
                },
                768: {
                    items: 2,
                    center: false,
                    margin: 50,
                    autoWidth: false,
                },
                992: {
                    items: 3,
                    margin: 30,
                    center: true,
                },
                1200: {
                    items: 4,
                    margin: 15,
                    center: false,
                },
                1400: {
                    items: 4,
                    margin: 30,
                    center: false,
                },
            }
        });
    }
};





export {projectSlider}
